import React__default from 'react';
import { useLocation } from 'react-router-dom';

function useUrlQueryParams() {
    const { search } = useLocation();
    return React__default.useMemo(() => new URLSearchParams(search), [search]);
}

export { useUrlQueryParams };
//# sourceMappingURL=useUrlQueryParams.js.map
